<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title"></h4>
    </div>
    <div v-if="selectedBetgame" class="card-content">
      <form>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Name"
                      placeholder="Name"
                      v-model="selectedBetgame.name">
            </fg-input>
          </div>
          <div class="col-md-3">

          </div>
          <div class="col-md-3">
            <fg-input type="number"
                      label="Id"
                      :disabled="true"
                      v-model="betgameId">
            </fg-input>
          </div>
        </div>

        <!--
        <div class="row">
          <div class="col-md-6">
            <label>Beschreibung</label>
            <textarea rows="3" class="form-control border-input"
                      placeholder="Beschreibung"
                      v-model="selectedBetgame.description">
              </textarea>
          </div>
        </div>
        -->

        <div class="row" style="margin-top: 10px;">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Email (wird innerhalb des Tippspiels als Kontakt angezeigt und als Absender von Emails verwendet)"
                      placeholder="Email"
                      v-model="selectedBetgame.email">
            </fg-input>
          </div>
          <div class="col-md-3">
          </div>
          <div v-if="this.$store.state.competitionData" class="col-md-3">
            <fg-input type="text"
                      label="Wettbewerb"
                      :disabled="true"
                      v-model="this.$store.state.competitionData.name">
            </fg-input>
          </div>
        </div>

        <div class="row" style="margin-top: 10px;">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Datenschutz-URL"
                      placeholder="Datenschutz-URL"
                      v-model="selectedBetgame.privacy">
            </fg-input>
          </div>
        </div>

        <div class="row" style="margin-top: 50px">
          <div class="col-md-12">
          </div>
        </div>

        <div v-if="this.isSPMUser()" class="row" style="margin-top: 10px;">
          <div class="col-md-6">
            <fg-input type="text"
                      label="* Google Analytics-Code (Google Analytics ist deaktiviert, wenn das Eingabefeld leer ist. Zwei durch Komma getrennte Codes sind möglich.)"
                      placeholder=""
                      v-model="selectedBetgame.analytics">
            </fg-input>
          </div>
        </div>

        <div v-if="this.isSPMUser() && fk_user.length > 0" class="row" style="margin-top: 10px;">
          <div class="col-md-6">
            <fg-input type="text"
                      label="* Admin-Id"
                      placeholder=""
                      v-model="fk_user">
            </fg-input>
          </div>
        </div>

        <div v-if="this.isSPMUser()" class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="* Einladungs-Link"
                      :disabled="true"
                      v-model="invitationLink">
            </fg-input>
          </div>
        </div>

        <div v-if="this.isSPMUser()" class="row" style="margin-top: 10px">
          <div class="col-md-6">
            <div>
              <label for="hide_ads">* Bwin deaktivieren</label>
              <input id="hide_ads" v-model="hide_ads" style="margin-left: 10px;" type="checkbox" name="hide_ads">
            </div>
          </div>
        </div>

        <div v-if="this.isSPMUser()" class="row" style="margin-top: 20px">
          <div class="col-md-6">
            <div>
              <label for="hide_ads">* {{ documentDomain }}</label>
            </div>
          </div>
        </div>

        <div class="text-right" style="margin-top: 30px; margin-bottom: 30px;">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="updateBetgame">
            Speichern
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        selectedBetgame: {},
        invitationLink: '',
        fk_user: '',
        hide_ads: false
      }
    },
    created () {
      if (!this.$store.state.betgameData) {
        this.$store.dispatch('fetchBetgame', this.$store.state.betgame)
      }
      if (!this.$store.state.competition && this.$store.state.betgame) {
        this.$store.dispatch('fetchBetgameCompetition', this.$store.state.betgame).then(() => {
        })
      } else {
        this.$store.dispatch('loadCompetitionData', this.$store.state.competition).then(() => {
          this.$store.dispatch('fetchSchedule', this.$store.state.competition).then(() => {
          })
        })
      }
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_BETGAME_DATA') {
          this.$log.debug('### SET_BETGAME_DATA ' + JSON.stringify(this.$store.state.betgameData))
          this.selectedBetgame = this.$store.state.betgameData
        }
      })
    },
    mounted () {
      this.selectedBetgame = this.$store.state.betgameData
      if (this.selectedBetgame) {
        if (!this.selectedBetgame.invitation_code) {
          this.selectedBetgame.invitation_code = Math.random().toString().slice(2, 10)
        }
        const d = window.sessionStorage.getItem('bgbackend_apiUrl') || 'https://teamtip.net'
        this.invitationLink = d + '/join/' + this.selectedBetgame.id + '/' + this.selectedBetgame.invitation_code
        this.fk_user = '' + this.selectedBetgame.fk_user
        this.hide_ads = this.selectedBetgame.hide_ads
      }
    },
    methods: {
      updateBetgame () {
        // alert('' + JSON.stringify(this.selectedBetgame))
        this.$store.dispatch('patchBetgame', {
          name: this.selectedBetgame.name,
          email: this.selectedBetgame.email,
          description: this.selectedBetgame.description,
          invitation_code: this.selectedBetgame.invitation_code,
          hide_ads: this.hide_ads,
          is_whitelabel: true,
          privacy: this.selectedBetgame.privacy,
          analytics: this.selectedBetgame.analytics,
          fk_user: this.fk_user.length > 0 && parseInt(this.fk_user) ? parseInt(this.fk_user) : this.selectedBetgame.fk_user
        })
          .then(() => {
            if (this.selectedBetgame) {
              this.selectedBetgame.hide_ads = this.hide_ads
            }
            alert('Tippspiel-Daten wurden aktualisiert')
          })
          .catch(function (error) {
            this.$log.debug(error)
          })
          .finally(function () {
          })
      }
    },
    computed: {
      betgameId () {
        return '' + this.selectedBetgame.id
      },
      documentDomain () {
        return document.domain + ' --- ' + window.sessionStorage.getItem('bgbackend_apiUrl')
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGEditBetgameForm.vue